export default __webpack_public_path__ + "8823655e3e1217c8ed99b33600cc65b3.png";